import React, { useState } from 'react';
import SortByFilterComponent from './SortByFilterComponent';
import { useLeadXchangeData } from '../Context/LeadXchangeData';
import { Box, ButtonBase } from '@material-ui/core';
import {
  CloseXIcon,
  SendIcon03,
  UsersLeftIcon,
} from '../../../../../../assets/icons';

import './LeadXChangeLeadActions.scss';
import SendToRotationDialog from '../Dialogs/SendToRotationDialog';
import LeadsXChangeReassignDialog from '../Dialogs/LeadsXChangeReassignDialog';
export default function LeadXChangeLeadActions({
  filter,
  setFilter,
  onClearedFiltersClick,
  reload,
  defaultFilter,
  setLoading
}) {
  const { actionableItems, setActionableItems } = useLeadXchangeData();

  const [openSendToRotationDialog, setOpenSendToRotationDialog] =
    useState(false);

  const [openReassignDialog, setOpenReassignDialog] = useState(false);

  const handleApplyButton = () => {
    if (actionableItems?.action === 'send-to-rotation') {
      setOpenSendToRotationDialog(true);
    }
    if (actionableItems?.action === 'reassign') {
      setOpenReassignDialog(true);
    }
  };

  return (
    <>
      <Box className='actions-container'>
        <Box className='actions-wrapper'>
          {actionableItems?.selectedIds?.length > 0 && (
            <>
              <ButtonBase>
                <CloseXIcon
                  onClick={() => {
                    setActionableItems({
                      selectedIds: [],
                      action: null,
                    });
                    setFilter(defaultFilter);
                  }}
                  width='20'
                  height='20'
                  fill='#344054'
                />
              </ButtonBase>

              <Box className='selectedCount'>
                {actionableItems?.selectedIds?.length} selected
              </Box>
            </>
          )}
          <ButtonBase
            className='leadxchange-general-button'
            onClick={() => {
              setActionableItems({
                selectedIds: [],
                action: 'reassign',
              });
              setFilter((prev) => ({
                ...prev,
                status: 1,
                leadClass: {
                  id: 3,
                  name: 'Buyer',
                },
              }));
            }}
          >
            <UsersLeftIcon
              width='20'
              height='20'
              fill='#344054'
            />
            <span className='buttonText'>Reassign lead</span>
          </ButtonBase>
          <ButtonBase
            className='leadxchange-general-button'
            onClick={() => {
              setActionableItems({
                selectedIds: [],
                action: 'send-to-rotation',
              });
              setFilter((prev) => ({
                ...prev,
                status: 1,
                leadClass: {
                  id: 3,
                  name: 'Buyer',
                },
              }));
            }}
          >
            <SendIcon03
              width='16'
              height='16'
              fill='#667085'
            />
            <span className='buttonText'>Send to rotation</span>
          </ButtonBase>
          {actionableItems?.action &&
            actionableItems?.selectedIds?.length > 0 && (
              <ButtonBase onClick={handleApplyButton}>
                <span className='buttonText-secondary'>Apply action</span>
              </ButtonBase>
            )}
          {actionableItems?.action && (
            <ButtonBase
              onClick={() => {
                setActionableItems({
                  selectedIds: [],
                  action: null,
                });
                setFilter(defaultFilter);
              }}
            >
              <span className='buttonText-secondary'>Cancel</span>
            </ButtonBase>
          )}
        </Box>
        <div className='sort-filter-container'>
          <SortByFilterComponent
            filter={filter}
            setFilter={setFilter}
          />
          <ButtonBase
            onClick={onClearedFiltersClick}
            id='onClearedAllFiltersref'
            className='clear-filters-button'
          >
            <span className='mdi mdi-filter-remove' />
          </ButtonBase>
        </div>
      </Box>

      {openSendToRotationDialog && (
        <SendToRotationDialog
          selectedIds={actionableItems?.selectedIds}
          open={openSendToRotationDialog}
          reload={reload}
          onClose={() => {
            setOpenSendToRotationDialog(false);
            setActionableItems({
              selectedIds: [],
              action: null,
            });
            setFilter(defaultFilter);
          }}
          setLoading={setLoading}
        />
      )}

      {openReassignDialog && (
        <LeadsXChangeReassignDialog
          selectedIds={actionableItems?.selectedIds}
          open={openReassignDialog}
          reload={reload}
          onClose={() => {
            setOpenReassignDialog(false);
            setActionableItems({
              selectedIds: [],
              action: null,
            });
            setFilter(defaultFilter);
          }}
          setLoading={setLoading}
        />
      )}
    </>
  );
}
